import Notifier from '../../components/messenger/Notifier'

new Notifier
